import { NiceNavigationItem } from "@recursyve/nice-ui-kit.v2";

export const batchUserNavigation: NiceNavigationItem[] = [
    {
        id: "home",
        type: "group",
        children: [
            {
                id: "fertilizer_tickets",
                title: "navigation.fertilizer_tickets.title",
                type: "collapsable",
                iconType: "fontawesome",
                icon: "fa-duotone fa-bag-seedling text-primary",
                children: [
                    {
                        id: "bin",
                        title: "navigation.fertilizer_tickets.dumpsters",
                        type: "basic",
                        iconType: "fontawesome",
                        icon: "fa-duotone fa-dumpster",
                        link: "/dashboard/bin"
                    },
                    {
                        id: "dashboard",
                        title: "navigation.fertilizer_tickets.fertilizer_tickets",
                        type: "basic",
                        iconType: "fontawesome",
                        icon: "fa-duotone fa-bars-staggered",
                        link: "/dashboard/ticket"
                    }
                ]
            }
        ]
    }
];
